import { render, staticRenderFns } from "./Kvarea.vue?vue&type=template&id=d412ddfa&"
import script from "./Kvarea.vue?vue&type=script&lang=js&"
export * from "./Kvarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports